import ReactDOM from "react-dom/client";
import App from "./App";
import { bootstrapThemeMode } from "./theme";
import { installViewAsFetchGuard } from "./utils/viewAsFetchGuard";

const RELOAD_KEY = "__chunk_reload";

function handleChunkLoadFailure(event: ErrorEvent | PromiseRejectionEvent) {
  const msg =
    event instanceof ErrorEvent
      ? event.message
      : String((event as PromiseRejectionEvent).reason);

  const isChunkError =
    /loading chunk/i.test(msg) ||
    /failed to fetch dynamically imported module/i.test(msg) ||
    /ChunkLoadError/i.test(msg);

  if (isChunkError && !sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
}

window.addEventListener("error", handleChunkLoadFailure);
window.addEventListener("unhandledrejection", handleChunkLoadFailure);

const container = document.getElementById("root")!;
const root = ReactDOM.createRoot(container);

installViewAsFetchGuard();
bootstrapThemeMode();

sessionStorage.removeItem(RELOAD_KEY);

root.render(<App />);
